import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Keyboard, X } from "lucide-react";
import { SHORTCUTS } from "@/hooks/useKeyboardShortcuts";

export default function ShortcutsModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const h = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center"
          data-testid="shortcuts-modal"
        >
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ scale: 0.96, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-md overflow-hidden rounded-2xl border border-white/10 bg-[#0f1730] shadow-2xl"
          >
            <div className="flex items-center justify-between border-b border-white/5 px-5 py-4">
              <div className="flex items-center gap-2">
                <Keyboard size={15} className="text-[#5B8DEF]" />
                <span className="font-display text-sm font-medium text-white">Keyboard shortcuts</span>
              </div>
              <button onClick={onClose} className="text-slate-400 hover:text-white" data-testid="close-shortcuts">
                <X size={14} />
              </button>
            </div>
            <ul className="divide-y divide-white/5">
              {SHORTCUTS.map((s) => (
                <li key={s.keys} className="flex items-center justify-between px-5 py-2.5 text-[13px]">
                  <span className="text-slate-300">{s.label}</span>
                  <span className="flex items-center gap-1">
                    {s.keys.split(" ").map((k, i) => (
                      <kbd key={i} className="rounded border border-white/10 bg-white/5 px-1.5 py-0.5 font-mono text-[10px] text-slate-300">
                        {k}
                      </kbd>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
